import { useState, useEffect } from 'react';
import { adminService } from '../services/adminService';

export function useTiposIva() {
  const [tiposIva,   setTiposIva]   = useState([]);
  const [ivaDefecto, setIvaDefecto] = useState(21);

  useEffect(() => {
    adminService.listarTiposIva()
      .then(r => setTiposIva(r.data))
      .catch(() => {});

    adminService.obtenerContadores()
      .then(r => { if (r.data?.iva != null) setIvaDefecto(r.data.iva); })
      .catch(() => {});
  }, []);

  return { tiposIva, ivaDefecto };
}
